import { useQuery } from "@tanstack/react-query";

import { finalAssessmentKeys } from "../../../redux/services/finalAssessmentKeys";

import { getFinalAssessmentApiCall } from "./utils.api";

export const useGetFinalAssessmentDetails = (userId) =>{
    return useQuery({
        queryKey: finalAssessmentKeys.getFinalAssessmentKeys({userId}),
        queryFn: () => getFinalAssessmentApiCall(userId),
    });
}